import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function getPaypalConfig() {
  const { data } = await axios.get(`${API}/paypal/config`);
  return data;
}

export async function completePaypal(orderId, productId) {
  const { data } = await axios.post(`${API}/paypal/complete`, {
    order_id: orderId,
    product_id: productId,
    origin: window.location.origin,
  });
  return data;
}

export async function notifySignup(email, productId = "dingo") {
  const { data } = await axios.post(`${API}/notify`, { email, product_id: productId });
  return data;
}

export async function getReviews(productId) {
  const params = productId ? { product_id: productId } : {};
  const { data } = await axios.get(`${API}/reviews`, { params });
  return data.reviews;
}

export async function submitReview(review) {
  const { data } = await axios.post(`${API}/reviews`, review);
  return data;
}
